module.exports = __webpack_public_path__ + "static/media/bear.6a615436.png";